import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=c64ce74a&scoped=true&"
import script from "./RadioInput.vue?vue&type=script&lang=js&"
export * from "./RadioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64ce74a",
  null
  
)

export default component.exports